import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { saveTemplate } from '../../../http/crm/email-campaigns';
import CModal from '../modal';
import CInput from '../input';
export default (props) => {
    const [name, setName] = React.useState('');
    const [subject, setSubject] = React.useState('');
    const [body, setBody] = React.useState('');
    React.useEffect(() => {
        var _a, _b, _c;
        if (props.visible) {
            setName(((_a = props.template) === null || _a === void 0 ? void 0 : _a.name) || '');
            setSubject(((_b = props.template) === null || _b === void 0 ? void 0 : _b.subject) || '');
            setBody(((_c = props.template) === null || _c === void 0 ? void 0 : _c.body) || '');
        }
    }, [props.visible, props.template]);
    const canSubmit = name.trim().length > 0 && subject.trim().length > 0 && body.trim().length > 0;
    const handleSubmit = (done) => {
        var _a;
        if (!canSubmit) {
            done();
            return;
        }
        const saved = saveTemplate({
            'id': (_a = props.template) === null || _a === void 0 ? void 0 : _a.id,
            'name': name.trim(),
            'subject': subject.trim(),
            'body': body,
        });
        props.onSaved(saved);
        done();
    };
    return _jsxs(CModal, { visible: props.visible, title: props.template ? 'Edit Template' : 'New Template', onClose: props.onClose, onSubmit: handleSubmit, action: "Save Template", lg: true, disabled: !canSubmit, children: [_jsx(CInput, { type: "text", value: name, onChange: setName, required: true, children: "Template Name" }), _jsx(CInput, { type: "text", value: subject, onChange: setSubject, required: true, children: "Subject Line" }), _jsx("label", { className: "form-label small text-muted", children: "Body" }), _jsx("textarea", { className: "form-control", rows: 10, value: body, onChange: (e) => setBody(e.currentTarget.value), placeholder: "Write your email here. Use {{first_name}} to personalize." }), _jsxs("p", { className: "small text-muted mt-2 mb-0", children: ["Tokens like ", '{{first_name}}', " are replaced with each recipient's info when sent."] })] });
};
